import { SlideOver } from "@/components/ui/slide-over";
import type { ScenarioCalendarOverride } from "@opus-dt/shared-types";
import { ScenarioCalendarSelector } from "./ScenarioCalendarSelector";

interface Props {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  scenarioId: string;
  lineId: string | null;
  initial: ScenarioCalendarOverride | null;
}

// Drawer do calendário do cenário no sandbox. O corpo remonta a cada abertura
// (key) p/ re-semear a partir do calendarOverride atual.
export function ScenarioCalendarDrawer({ open, onOpenChange, scenarioId, lineId, initial }: Props) {
  return (
    <SlideOver open={open} onOpenChange={onOpenChange} title="Calendário do cenário" width={560}>
      {open ? (
        <ScenarioCalendarSelector
          scenarioId={scenarioId}
          lineId={lineId}
          initial={initial}
          onDone={() => onOpenChange(false)}
        />
      ) : null}
    </SlideOver>
  );
}
